export default __webpack_public_path__ + "static/IBMPlexSans-Italic-7fe9306988ce219247a136fc5857ebd6.woff";